<template>
  <Layout>
    <PageHeader :title="title" :items="braedcrumb" />
    <b-overlay :show="isBusy">
      <div class="row">
        <div class="col">
          <div class="card">
            <div class="row m-2">
              <div>
                <div>
                  <b-row>
                    <b-col sm="12" lg="2" class="my-1">
                      <!-- <date-picker
                        v-model="filter.StartDate"
                        format="DD.MM.YYYY"
                        style="width: 100%"
                        value-type="format"
                        :editable="true"
                        :placeholder="$t('StartDate')"
                      ></date-picker> -->
                      <custom-date-picker
                        v-model="filter.StartDate"
                        format="DD.MM.YYYY"
                        type="date"
                        :clearable="false"
                        :placeholder="$t('docdate')"
                        @keyup="BindValueStart"
                      >
                      </custom-date-picker>
                    </b-col>
                    <b-col sm="12" lg="2" class="my-1">
                      <!-- <date-picker
                        v-model="filter.EndDate"
                        format="DD.MM.YYYY"
                        style="width: 100%"
                        value-type="format"
                        :editable="true"
                        :placeholder="$t('EndDate')"
                      ></date-picker> -->
                      <custom-date-picker
                        v-model="filter.EndDate"
                        format="DD.MM.YYYY"
                        type="date"
                        :clearable="false"
                        :placeholder="$t('docdate')"
                        @keyup="BindValueEndDate"
                      >
                      </custom-date-picker>
                    </b-col>
                    <b-col sm="12" lg="2" style="margin-top: 5px">
                      <v-select
                        :options="ItemGroupList"
                        :reduce="item => item.item_group_name"
                        :placeholder="$t('ItemGroupName')"
                        label="item_group_name"
                        @input="Refresh"
                        v-model="filter.ItemGroupName"
                      ></v-select>
                    </b-col>
                    <b-col md="2" sm="12" class="my-1">
                      <v-select
                        :options="TradeTypeList"
                        :reduce="item => item.id"
                        :placeholder="$t('tradetype')"
                        label="name"
                        @input="Refresh"
                        v-model="filter.TradeTypeId"
                      ></v-select>
                    </b-col>
                    <b-col sm="12" lg="2">
                      <custom-number-input
                        @input="Refresh"
                        :placeholder="$t('summa')"
                        v-model="filter.Summa"
                      ></custom-number-input>
                    </b-col>
                    <b-col sm="12" lg="2" md="2">
                      <b-button
                        class="float-right"
                        variant="primary"
                        size="md"
                        @click="Print"
                      >
                        <b-icon v-if="!PrintLoading" icon="printer"></b-icon>
                        <b-spinner v-if="PrintLoading" small></b-spinner>
                        {{ $t("Print") }}
                      </b-button>
                    </b-col>
                    <!-- <b-col md="2" cols="12">
                      <v-select
                        :options="ProductCategoryList"
                        :reduce="(item) => item.id"
                        :placeholder="$t('SelectProductCategory')"
                        label="name"
                        @input="Refresh"
                        v-model="filter.ProductCategoryId"
                      ></v-select>
                    </b-col> -->
                  </b-row>
                  <b-row class="mt-1">
                    <b-col sm="12" lg="2" class="text-right my-1">
                      <b-input-group>
                        <b-form-input
                          :placeholder="$t('search')"
                          v-model="filter.Search"
                        ></b-form-input>
                        <b-input-group-append>
                          <b-button @click="Refresh" variant="primary">
                            <i class="fas fa-search"></i>
                          </b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-col>
                    <b-col
                      md="2"
                      cols="12"
                      class="my-1"
                      v-if="
                        $can('XTVView', 'permissions') ||
                          $can('AdminView', 'permissions')
                      "
                    >
                      <v-select
                        :options="OblastList"
                        :reduce="item => item.id"
                        :placeholder="$t('SelectOblast')"
                        label="name"
                        @input="OblastChange"
                        v-model="filter.OblastId"
                      ></v-select>
                    </b-col>
                    <b-col
                      sm="12"
                      md="2"
                      class="my-1"
                      v-if="
                        $can('XTVView', 'permissions') ||
                          $can('AdminView', 'permissions') ||
                          $can('OblastXTBView', 'permissions')
                      "
                    >
                      <v-select
                        :options="RegionList"
                        :reduce="item => item.id"
                        :placeholder="$t('SelectRegion')"
                        label="name"
                        @input="RegionChange"
                        v-model="filter.RegionId"
                      ></v-select>
                    </b-col>
                    <b-col
                      sm="12"
                      md="3"
                      lg="3"
                      class="my-1"
                      v-if="
                        $can('XTVView', 'permissions') ||
                          $can('RegionXTBView', 'permissions')
                      "
                    >
                      <v-select
                        :options="OrganizationList"
                        :reduce="item => item.id"
                        :placeholder="$t('buyername')"
                        label="name"
                        @input="Refresh"
                        v-model="filter.OrganizationId"
                      ></v-select>
                    </b-col>
                  </b-row>
                  <b-row class="mt-3">
                    <b-col class="text-left">
                      <a href="javascript:void(0)" @click="topCountryChange">
                        {{ $t("uzb") }}
                      </a>
                      <span v-if="filter.oblastname !== ''" class="text-primary"
                        >/</span
                      ><a href="javascript:void(0)" @click="topOblastChange">
                        {{ filter.oblastname }}
                      </a>
                    </b-col>
                    <!-- Hugoo -->
                  </b-row>
                </div>
              </div>
            </div>
            <div class="row m-2">
              <div
                class="table-container"
                style="
                  overflow-x: auto;
                  overflow-y: auto;
                  height: 65vh;
                  padding: 5px;
                "
              >
                <b-table-simple class="table table-bordered table-responsive">
                  <b-thead>
                    <b-tr>
                      <b-th
                        variant="info"
                        style="
                          text-align: center;
                          vertical-align: middle;
                          position: sticky;
                          top: -10px;
                        "
                      >
                        <!-- {{ $t("actions") }} -->
                        {{ $t("actions") }}
                      </b-th>
                      <b-th
                        variant="info"
                        style="
                          text-align: center;
                          vertical-align: middle;
                          position: sticky;
                          top: -10px;
                        "
                      >
                        <div
                          class="text-center"
                          style="cursor: pointer"
                          @click="ChangeSort('oblastname')"
                        >
                          {{ $t("oblast") }}
                          <i
                            v-if="filter.SortColumn === 'oblastname'"
                            :class="filter.SortIcon"
                          ></i>
                        </div>
                      </b-th>
                      <b-th
                        variant="info"
                        style="
                          text-align: center;
                          vertical-align: middle;
                          position: sticky;
                          top: -10px;
                        "
                      >
                        <div
                          class="text-center"
                          style="cursor: pointer"
                          @click="ChangeSort('regionname')"
                        >
                          {{ $t("region") }}
                          <i
                            v-if="filter.SortColumn === 'regionname'"
                            :class="filter.SortIcon"
                          ></i>
                        </div>
                      </b-th>

                      <b-th
                        variant="info"
                        style="
                          text-align: center;
                          vertical-align: middle;
                          position: sticky;
                          top: -10px;
                        "
                      >
                        <div
                          class="text-center"
                          style="cursor: pointer"
                          @click="ChangeSort('buyername')"
                        >
                          {{ $t("buyername") }}
                          <i
                            v-if="filter.SortColumn === 'buyername'"
                            :class="filter.SortIcon"
                          ></i>
                        </div>
                      </b-th>
                      <b-th
                        variant="info"
                        style="
                          text-align: center;
                          vertical-align: middle;
                          position: sticky;
                          top: -10px;
                        "
                      >
                        <div
                          class="text-center"
                          style="cursor: pointer"
                          @click="ChangeSort('art_id')"
                        >
                          {{ $t("art_id") }}
                          <i
                            v-if="filter.SortColumn === 'art_id'"
                            :class="filter.SortIcon"
                          ></i>
                        </div>
                      </b-th>
                      <b-th
                        variant="info"
                        style="
                          text-align: center;
                          vertical-align: middle;
                          position: sticky;
                          top: -10px;
                        "
                      >
                        <div
                          class="text-center"
                          style="cursor: pointer"
                          @click="ChangeSort('dateini')"
                        >
                          {{ $t("ondate") }}
                          <i
                            v-if="filter.SortColumn === 'dateini'"
                            :class="filter.SortIcon"
                          ></i>
                        </div>
                      </b-th>
                      <b-th
                        variant="info"
                        style="
                          text-align: center;
                          vertical-align: middle;
                          position: sticky;
                          top: -10px;
                        "
                      >
                        <div
                          class="text-center"
                          style="cursor: pointer"
                          @click="ChangeSort('item_group_name')"
                        >
                          {{ $t("item_group_name") }}
                          <i
                            v-if="filter.SortColumn === 'item_group_name'"
                            :class="filter.SortIcon"
                          ></i>
                        </div>
                      </b-th>
                      <b-th
                        variant="info"
                        style="
                          text-align: center;
                          vertical-align: middle;
                          position: sticky;
                          top: -10px;
                        "
                      >
                        <div
                          class="text-center"
                          style="cursor: pointer"
                          @click="ChangeSort('item_name')"
                        >
                          {{ $t("item_name") }}
                          <i
                            v-if="filter.SortColumn === 'item_name'"
                            :class="filter.SortIcon"
                          ></i>
                        </div>
                      </b-th>
                      <b-th
                        variant="info"
                        style="
                          text-align: center;
                          vertical-align: middle;
                          position: sticky;
                          top: -10px;
                        "
                      >
                        <div
                          class="text-center"
                          style="cursor: pointer"
                          @click="ChangeSort('tradetypename')"
                        >
                          {{ $t("tradetypename") }}
                          <i
                            v-if="filter.SortColumn === 'tradetypename'"
                            :class="filter.SortIcon"
                          ></i>
                        </div>
                      </b-th>
                      <b-th
                        variant="info"
                        style="
                          text-align: center;
                          vertical-align: middle;
                          position: sticky;
                          top: -10px;
                        "
                      >
                        <div
                          class="text-center"
                          style="cursor: pointer"
                          @click="ChangeSort('summa')"
                        >
                          {{ $t("quantity") }} / {{ $t("summa") }}
                          <i
                            v-if="filter.SortColumn === 'summa'"
                            :class="filter.SortIcon"
                          ></i>
                        </div>
                      </b-th>
                      <b-th
                        variant="info"
                        style="
                          text-align: center;
                          vertical-align: middle;
                          position: sticky;
                          top: -10px;
                        "
                      >
                        {{ $t("participantscount") }} / {{ $t("bids") }}
                      </b-th>
                      <b-th
                        variant="info"
                        style="
                          text-align: center;
                          vertical-align: middle;
                          position: sticky;
                          top: -10px;
                        "
                      >
                        <div
                          class="text-center"
                          style="cursor: pointer"
                          @click="ChangeSort('sellerregion')"
                        >
                          {{ $t("sellerregion") }}
                          <i
                            v-if="filter.SortColumn === 'sellerregion'"
                            :class="filter.SortIcon"
                          ></i>
                        </div>
                      </b-th>
                      <b-th
                        variant="info"
                        style="
                          text-align: center;
                          vertical-align: middle;
                          position: sticky;
                          top: -10px;
                        "
                      >
                        <div
                          class="text-center"
                          style="cursor: pointer"
                          @click="ChangeSort('sellerrayon')"
                        >
                          {{ $t("sellerrayon") }}
                          <i
                            v-if="filter.SortColumn === 'sellerrayon'"
                            :class="filter.SortIcon"
                          ></i>
                        </div>
                      </b-th>
                      <b-th
                        variant="info"
                        style="
                          text-align: center;
                          vertical-align: middle;
                          position: sticky;
                          top: -10px;
                        "
                      >
                        <div
                          class="text-center"
                          style="cursor: pointer"
                          @click="ChangeSort('sellername')"
                        >
                          {{ $t("sellername") }}
                          <i
                            v-if="filter.SortColumn === 'sellername'"
                            :class="filter.SortIcon"
                          ></i>
                        </div>
                      </b-th>
                      <b-th
                        variant="info"
                        style="
                          text-align: center;
                          vertical-align: middle;
                          position: sticky;
                          top: -10px;
                        "
                      >
                        <div
                          class="text-center"
                          style="cursor: pointer"
                          @click="ChangeSort('status_name')"
                        >
                          {{ $t("state") }}
                          <i
                            v-if="filter.SortColumn === 'status_name'"
                            :class="filter.SortIcon"
                          ></i>
                        </div>
                      </b-th>
                    </b-tr>
                  </b-thead>

                  <b-tbody>
                    <tr
                      v-for="(item, i) in items"
                      style="text-align: center; vertical-align: middle"
                      :key="i"
                    >
                      <td style="text-align: center; vertical-align: middle">
                        <b-link
                          @click="OpenViewModal(item)"
                          v-b-tooltip.hover.top="$t('View')"
                          style="margin-right: 5px"
                        >
                          <i class="mdi mdi-eye"></i>
                        </b-link>
                      </td>
                      <td style="text-align: left; vertical-align: middle">
                        {{ item.oblastname }}
                      </td>
                      <td style="text-align: left; vertical-align: middle">
                        {{ item.regionname }}
                      </td>

                      <td style="text-align: left">
                        <b-link
                          @click="
                            $router.push({
                              name: 'BuyerCard',
                              query: { buyerid: 0, buyertin: item.buyerinn }
                            })
                          "
                          >{{ item.buyername }}
                          <b> ({{ item.buyerinn }}) </b></b-link
                        >
                      </td>
                      <td style="font-weight: bold; text-align: left">
                        {{ item.art_id }}
                      </td>
                      <td style="text-align: right">
                        {{ item.dateini }}-
                        {{ item.date_end }}
                      </td>
                      <td style="text-align: left">
                        {{ item.item_group_name }}
                      </td>
                      <td style="text-align: left">
                        {{ item.item_name }}
                      </td>
                      <td style="text-align: left">
                        {{ item.tradetypename }}
                      </td>
                      <td style="text-align: right; white-space: nowrap">
                        {{
                          $options.filters.currency(item.quantity, {
                            symbol: "",
                            fractionCount: 0
                          })
                        }}
                        /
                        {{
                          $options.filters.currency(item.summa, {
                            symbol: "",
                            fractionCount: 0
                          })
                        }}
                      </td>
                      <td style="text-align: right; white-space: nowrap">
                        {{
                          $options.filters.currency(item.participantscount, {
                            symbol: "",
                            fractionCount: 0
                          })
                        }}
                        /
                        {{
                          $options.filters.currency(item.bidscount, {
                            symbol: "",
                            fractionCount: 0
                          })
                        }}
                      </td>
                      <td style="text-align: left; vertical-align: middle">
                        {{ item.sellerregion == null ? "" : item.sellerregion }}
                      </td>
                      <td style="font-weight: bold; text-align: left">
                        {{ item.sellerrayon == null ? "" : item.sellerrayon }}
                      </td>
                      <td style="font-weight: bold; text-align: right">
                        {{ item.sellername }} <b> ({{ item.sellerinn }}) </b>
                      </td>
                      <td style="text-align: right">
                        {{ item.status_name }}
                      </td>
                      <b-modal
                        :id="'ViewModal' + item.id"
                        :title="$t('View')"
                        hide-footer
                        ok-variant="success"
                        size="xl"
                        hide-header-close
                      >
                        <UzexLotViewComponent :id="item.id" />
                        <b-row>
                          <b-col class="text-end">
                            <b-button
                              @click="$bvModal.hide('ViewModal' + item.id)"
                              variant="success"
                            >
                              Ok
                            </b-button>
                          </b-col>
                        </b-row>
                      </b-modal>
                    </tr>
                    <!-- <tr
                      style="
                        text-align: right;
                        vertical-align: middle;
                        font-weight: bold;
                      "
                    >
                      <td>{{ $t("Total") }}</td>
                      <td style="white-space: nowrap">
                        
                      </td>
                      <td style="white-space: nowrap">
                       
                      </td>
                      <td style="white-space: nowrap">
                        
                      </td>
                      <td style="white-space: nowrap">
                       
                      </td>
                      <td style="white-space: nowrap">
                        
                      </td>
                      <td style="white-space: nowrap">
                       
                      </td>
                      <td style="white-space: nowrap">
                      
                      </td>
                      <td style="white-space: nowrap">
                        
                      </td>
                      <td style="white-space: nowrap">
                        
                      </td>
                      <td style="white-space: nowrap">
                       
                      </td>
                      <td style="white-space: nowrap">
                        {{
                          total.totalquantity == 0
                            ? "-"
                            : $options.filters.currency(total.totalquantity, {
                                symbol: "",
                                fractionCount: 0,
                              })
                        }}
                      </td>
                      <td style="white-space: nowrap">
                        {{
                          total.totalsumma == 0
                            ? "-"
                            : $options.filters.currency(total.totalsumma, {
                                symbol: "",
                                fractionCount: 0,
                              })
                        }}
                      </td>
                      <td></td>
                    </tr> -->
                  </b-tbody>
                </b-table-simple>

                <br />
              </div>
            </div>
            <div>
              <b-row class="m-2">
                <b-col
                  cols="12"
                  sm="6"
                  class="d-flex align-items-center justify-content-center justify-content-sm-start"
                >
                  <span class="text-muted">
                    {{ $t("Showing") }} {{ firstNumber }} {{ $t("to") }}
                    {{ lastNumber }} {{ $t("of") }}
                    <b> {{ filter.totalRows }} </b> {{ $t("entries") }}
                  </span>
                </b-col>
                <b-col
                  cols="12"
                  sm="6"
                  class="d-flex align-items-center justify-content-center justify-content-sm-end"
                >
                  <b-pagination
                    class="mb-0 mt-1 mt-sm-0"
                    prev-class="prev-item"
                    next-class="next-item"
                    @input="Refresh"
                    :per-page="filter.PageLimit"
                    :total-rows="filter.totalRows"
                    v-model="filter.PageNumber"
                  >
                    <template #prev-text>
                      <i class="fas fa-angle-left"></i>
                    </template>
                    <template #next-text>
                      <i class="fas fa-angle-right"></i>
                    </template>
                  </b-pagination>
                </b-col>
              </b-row>
            </div>
          </div>
        </div>
      </div>
    </b-overlay>
  </Layout>
</template>

<script>
import Layout from "@/router/layouts/main";
import Multiselect from "vue-multiselect";
import DatePicker from "vue2-datepicker";
import PageHeader from "@/components/page-header";
import ReportService from "@/services/reports/report.service";
import UzexService from "@/services/others/uzex.service";
import HelperService from "@/services/others/helper.service";
import ProductCategoryService from "@/services/info/productcategory.service";
import CustomDatePicker from "../../../components/customDatePicker.vue";
import OrganizationService from "@/services/others/organization.service";
import UzexLotViewComponent from "@/components/UzexLotViewComponent.vue";
import OblastService from "@/services/info/oblast.service";
import RegionService from "@/services/info/region.service";
import CustomNumberInput from "../../../components/CustomNumberInput.vue";
export default {
  components: {
    Layout,
    PageHeader,
    Multiselect,
    DatePicker,
    CustomDatePicker,
    UzexLotViewComponent,
    CustomNumberInput
  },
  data() {
    return {
      title: this.$t("AuctionInfoByStatus"),
      braedcrumb: [
        {
          text: this.$t("Reports")
        },
        {
          text: this.$t("AuctionInfoByStatus"),
          active: true
        }
      ],
      isLoading: false,
      PrintLoading: false,
      filter: {
        OblastId: 0,
        RegionId: 0,
        OrganizationId: 0,
        ItemGroupName: "",
        TradeTypeId: 0,
        StartDate: "",
        EndDate: "",
        Search: "",
        SortColumn: "",
        OrderType: "asc",
        Summa: "",
        PageNumber: 1,
        PageLimit: 20,
        perPageOptions: [10, 20, 50, 100],
        totalRows: 0,
        SortIcon: "bx bxs-up-arrow"
      },
      total: {
        totalquantity: 0,
        totalsumma: 0
      },
      items: [],
      OblastList: [],
      RegionList: [],
      TradeTypeList: [],
      ProductCategoryList: [],
      OrganizationList: [],
      isBusy: false,
      ItemGroupList: [],
      lang: localStorage.getItem("locale") || "ru"
    };
  },
  computed: {
    firstNumber() {
      return (this.filter.PageNumber - 1) * this.filter.PageLimit + 1;
    },
    lastNumber() {
      if (this.filter.totalRows < this.filter.PageLimit) {
        return this.filter.totalRows;
      } else {
        if (
          this.filter.PageNumber * this.filter.PageLimit >
          this.filter.totalRows
        ) {
          return this.filter.totalRows;
        } else {
          return this.filter.PageNumber * this.filter.PageLimit;
        }
      }
    }
  },
  created() {
    var today = new Date();
    var todaydate = new Date();
    var dd = String(todaydate.getDate()).padStart(2, "0");
    var mn = String(todaydate.getMonth() - 1).padStart(2, "0");
    var mm = String(todaydate.getMonth() + 1).padStart(2, "0");
    var yyyy = todaydate.getFullYear();
    var day =
      today.getDate() +
      "." +
      (today.getMonth() + 1) +
      "." +
      today.getFullYear();
    this.filter.StartDate = "01" + "." + mm + "." + yyyy;
    this.filter.EndDate = dd + "." + mm + "." + yyyy;
    if (this.$store.state.AllUzexLot.StartDate != undefined) {
      this.filter = this.$store.state.AllUzexLot;
    }
    this.Refresh();
    OblastService.GetAll(this.lang).then(res => {
      this.OblastList = res.data;
    });
    HelperService.GetAllTradeType().then(res => {
      this.TradeTypeList = res.data;
    });
    ProductCategoryService.GetAll(this.lang).then(res => {
      this.ProductCategoryList = res.data;
    });
    UzexService.GetAllUzexItemGroup().then(res => {
      this.ItemGroupList = res.data.result;
    });
  },
  methods: {
    OpenViewModal(item) {
      this.$bvModal.show("ViewModal" + item.id);
    },
    sortChanged() {
      // eslint-disable-next-line no-alert
      alert(1);
    },
    BindValueStart(value) {
      this.filter.StartDate = value;
    },
    BindValueEndDate(value) {
      this.filter.EndDate = value;
    },
    calculate() {
      this.total = {
        totalquantity: 0,
        totalsumma: 0
      };
      for (var i = 0; i < this.items.length; i++) {
        this.total.totalsumma += 1 * this.items[i].summa;
        this.total.totalquantity += 1 * this.items[i].quantity;
      }
    },
    SortChange(data) {
      this.filter.SortColumn = data.sortBy;
      this.filter.OrderType = data.sortDesc ? "desc" : "asc";
      this.Refresh();
    },
    saveFilter() {
      this.$store.state.AllUzexLot = this.filter;
    },
    ChangeSort(columnName) {
      this.filter.SortColumn = columnName;
      if (this.filter.OrderType == "asc") {
        this.filter.SortIcon = "bx bxs-down-arrow";
        this.filter.OrderType = "desc";
      } else {
        this.filter.SortIcon = "bx bxs-up-arrow";
        this.filter.OrderType = "asc";
      }
      this.Refresh();
    },
    forceFileDownload(response, name) {
      var headers = response.headers;
      var blob = new Blob([response.data]);
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;

      link.setAttribute("download", name + ".xlsx"); //or any other extension
      document.body.appendChild(link);
      link.click();
    },

    Print() {
      this.PrintLoading = true;
      ReportService.PrintAllUzexLot(
        this.filter.OblastId,
        this.filter.RegionId,
        this.filter.OrganizationId,
        this.filter.ItemGroupName,
        this.filter.TradeTypeId,
        this.filter.StartDate,
        this.filter.EndDate,
        this.filter.Search,
        this.filter.SortColumn,
        this.filter.OrderType,
        this.filter.PageNumber,
        this.filter.PageLimit,
        this.filter.Summa
      )
        .then(response => {
          this.PrintLoading = false;
          this.forceFileDownload(response, this.$t("AuctionInfoByStatus"));
        })
        .catch(e => {
          this.PrintLoading = false;
          let response = JSON.parse(e.request.response);

          self.makeToast(response.error, self.$t("actions.error"), "danger");
        });
    },
    Refresh() {
      if (this.filter.ItemGroupName == null) {
        this.filter.ItemGroupName = "";
      }
      this.isBusy = true;
      this.saveFilter();
      ReportService.GetAllUzexLot(
        this.filter.OblastId,
        this.filter.RegionId,
        this.filter.OrganizationId,
        this.filter.ItemGroupName,
        this.filter.TradeTypeId,
        this.filter.StartDate,
        this.filter.EndDate,
        this.filter.Search,
        this.filter.SortColumn,
        this.filter.OrderType,
        this.filter.PageNumber,
        this.filter.PageLimit,
        this.filter.Summa
      )
        .then(res => {
          this.items = res.data.data.rows;
          this.filter.totalRows = res.data.data.total;
          if (!!res.data.oblastid) {
            this.filter.OblastId = res.data.oblastid;
          }
          if (!!res.data.regionid) {
            this.filter.RegionId = res.data.regionid;
          }
          // if(this.$can('OblastXTBView','permissions')){
          //   this.getRegionList()
          // }
          if (res.data.regionid != null || res.data.regionid != 0) {
            this.getRegionList();
            if (!!this.filter.RegionId) {
              OrganizationService.GetAll(
                this.filter.OblastId,
                this.filter.RegionId,
                false
              ).then(res => {
                this.OrganizationList = res.data;
              });
            }
          }
          this.isBusy = false;
          //   this.calculate();
        })
        .catch(error => {
          this.isBusy = false;
          this.$notification(error.response.data.error, "danger");
        });
    },
    OblastChange() {
      this.filter.RegionId = 0;
      this.filter.OrganizationId = 0;
      if (!!this.filter.OblastId) {
        this.getRegionList();
      }
      this.Refresh();
    },
    a() {},
    getRegionList() {
      RegionService.GetAll(this.lang, this.filter.OblastId).then(res => {
        this.RegionList = res.data;
      });
    },
    RegionChange() {
      this.filter.OrganizationId = 0;
      if (!!this.filter.RegionId) {
        OrganizationService.GetAll(
          this.filter.OblastId,
          this.filter.RegionId,
          false
        ).then(res => {
          this.OrganizationList = res.data;
        });
      }
      this.Refresh();
    },
    topCountryChange() {
      this.filter.oblastname = "";
      this.filter.OblastId = 0;
      this.fields[0].key = "oblastname";
      this.fields[0].label = this.$t("Oblast");
      this.Refresh();
    },
    topOblastChange() {
      this.filter.regionname = "";
      this.filter.RegionId = 0;
      this.fields[0].key = "regionname";
      this.fields[0].label = this.$t("Region");
      this.Refresh();
    },
    ChangeOblast(item) {
      this.filter.OblastId = item.oblastid;
      this.fields[0].key = "regionname";
      this.filter.oblastname = item.oblastname;
      this.fields[0].label = this.$t("Region");
      this.Refresh();
    },
    ChangeRegion(item) {
      this.$router.push({
        name: "AuctionLotInfo",
        query: {
          oblastid: item.oblastid,
          regionid: item.regionid
        }
      });
    }
  }
};
</script>

<style>
.text-right {
  text-align: right;
}
</style>
